/** Control first, label and note beside it. Shared by a leading Field and every Field.Item. */
export const LEADING_LAYOUT = [
  'grid grid-cols-[auto_minmax(0,1fr)] grid-rows-[minmax(18px,auto)] items-start gap-x-2 gap-y-0.5',
  '[&>[data-slot=field-label]]:col-start-2 [&>[data-slot=field-note]]:col-start-2',
  // Centred on the label's first line, which is the row it shares.
  '[&>*:not([data-slot=field-label]):not([data-slot=field-note])]:col-start-1 [&>*:not([data-slot=field-label]):not([data-slot=field-note])]:row-start-1 [&>*:not([data-slot=field-label]):not([data-slot=field-note])]:self-center',
  '[&:has([role=checkbox],[role=radio])>[data-slot=field-label]]:cursor-pointer',
].join(' ')

/**
 * Greys a label or note when the Field holds a disabled control. A control inside a Field.Item only
 * counts once every control is disabled, so one disabled option does not grey the whole group but a
 * disabled group does; each Item greys its own label and note.
 */
export const FIELD_DISABLED_TEXT = [
  'group-has-[:disabled:not([data-slot=field-item]_*)]/field:text-foreground-disabled',
  'group-[:has(:disabled):not(:has(:enabled))]/field:text-foreground-disabled',
].join(' ')
